export default "__VITE_ASSET__Cmq8XZk3__"